<div [formGroup]="daypartMatrixControl">
  <targeting-container label="Dayparting" [hideRemove]="true" (onEdit)="openSidebar()" [disabled]="isDisabled">
    <div class="d-inline-block">
      <div class="selected-daypart">
        <span class="chip-container" *ngFor="let item of selectedItems" [class.disabled]="isDisabled">
          <acl-ngx-tooltip [trigger]="trigger" [disabled]="!item.moreItem" [text]="item.moreItem">
          </acl-ngx-tooltip>
          <ng-template #trigger>
            <acl-ngx-chip [text]="item.text">
            </acl-ngx-chip>
          </ng-template>
        </span>
      </div>
    </div>
    <acl-ngx-flyout [open]="open" (close)="cancel()" portalRoot="daypart-targeting">
      <acl-ngx-flyout-header title="Dayparting" (close)="cancel()">
      </acl-ngx-flyout-header>
      <acl-ngx-flyout-body>
        <div>
          <div class="constraint-content container-fluid">
            <dayparting-grid [daypartGrid]="daypartGrid">
            </dayparting-grid>
          </div>
        </div>
      </acl-ngx-flyout-body>
      <acl-ngx-flyout-footer [rightButton]="saveButton" [leftButton]="cancelButton"></acl-ngx-flyout-footer>
    </acl-ngx-flyout>
  </targeting-container>
</div>